import { Box, Container, Paper, Typography } from '@mui/material';
import { ActionsButton } from '../../../../ui/components/pure/actions-button/actions-button.component';
import { LoadedActionsButtonItem } from '../../../../ui/components/pure/actions-button/actions-button.types';
import { LoadingIndicator } from '../../../../ui/components/pure/loading-indicator/loading-indicator.component';
import { useTextStyles } from '../../../../ui/theme/text';
import { useSettingsTreePanelStyles } from './settings-tree-panel.styles';
import { SettingsTree, SettingsTreeProps } from './settings-tree.component';

export interface SettingsPanelProps extends SettingsTreeProps {
  actionButtonActions: LoadedActionsButtonItem[];
  // Whether an expanded project's children are still loading (shows an inline spinner under the tree).
  isLoadingChildren?: boolean;
}

export function SettingsTreePanel(props: SettingsPanelProps) {
  const classes = useSettingsTreePanelStyles();
  const textClasses = useTextStyles();

  return (
    <Paper className={classes.paper}>
      <Box className={classes.title}>
        <Typography className={textClasses.h2}>{props.title}</Typography>
        <ActionsButton itemArray={props.actionButtonActions} variant="light" />
      </Box>
      <Container>
        <SettingsTree {...props} />
        {props.isLoadingChildren && <LoadingIndicator size="small" />}
      </Container>
    </Paper>
  );
}
